import { getRemainingTimeTexts } from '../../../utils';
import { isProjectADugnad, isStartingInTheFuture } from '../../project-model';
import moment from 'moment';
import styles from './ProjectInactiveBanner.module.less';

export const ProjectInactiveBanner = ({ project, className }) => {
    const { generalText: statusText, isWarningStatus } = getRemainingTimeTexts(project);

    return (
        <div
            className={[
                'ffe-accent-mode',
                styles.projectIsInactive,
                isWarningStatus ? styles.projectWarningStatus : styles.projectStatus,
                className,
            ].join(' ')}
        >
            <span suppressHydrationWarning>
                {isStartingInTheFuture(project) ? (
                    <span className={styles.startingInTheFutureInfo}>
                        {isProjectADugnad(project) ? 'Dugnaden' : 'Spleisen'} blir automatisk aktiv fra og med{' '}
                        <span className={styles.startingInTheFutureInfoDate}>
                            {moment(project.published_at).format('DD. MMMM')}
                        </span>{' '}
                        {moment(project.published_at).format('YYYY')}. Først da blir det mulig å samle inn
                        penger.&nbsp;🚀
                    </span>
                ) : (
                    statusText
                )}
            </span>
        </div>
    );
};
